import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/Rx";

@Injectable()
export class AccountService {

  public userAccount = new BehaviorSubject<any>({});
  public authToken = new BehaviorSubject<any>("");

  constructor() {
    this.authToken.subscribe(token => {
      if (token) {
        localStorage.setItem("token", token);
      }
    });
    this.userAccount.subscribe(user => {
      if (JSON.stringify(user) !== "{}") {
        localStorage.setItem("user", JSON.stringify(user));
      }
    })
   }

  updateAccount(account) {
    this.userAccount.next(account);
  }

  updateAuthToken(token) {
    this.authToken.next(token);
  }

  clearAccount() {
    this.userAccount.next({});
    this.authToken.next("");
    localStorage.clear();
  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/account/account.service.ts